/*
--- 
description: FED Process
authors: 
- David Chan CK
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var site;


// console.log('site');
// // Track changes to scrollTop for document.documentElement (HTML element) and document.body
// window.addEventListener('scroll', function() {
//     window.requestAnimationFrame(function() {
//         console.log('Scroll event triggered. Scroll position:', window.scrollY);
//         console.trace(); // Capture stack trace after the scroll event
//     });
// });



// const observer = new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//         console.log('A DOM mutation occurred:', mutation);
//         console.log('Current scroll position:', window.scrollY);
//         console.trace(); // Capture stack trace when DOM is modified
//     });
// });

// observer.observe(document.body, { childList: true, subtree: true });


// window.addEventListener('DOMContentLoaded', function() {
//     if (window.location.hash) {
//         console.log('Hash detected:', window.location.hash);
//         window.scrollTo(0, 0); // Prevent scroll to anchor
//     }
// });



// document.addEventListener('focusin', function(event) {
//     console.log(`Focus event on:`, event.target);
//     console.trace(); // Trace focus-induced scroll behavior
// });


window.addEvent('domready', function()
{    
	site = new Site();
});